<div id="backdrop" *ngIf="show">
  <!-- <div class="loader"> -->
    <!-- <fa-icon [icon]="faSpinnerThird" class="fa-spin" [spin]="true"></fa-icon> -->
  <!-- </div> -->
  <div class="ball-scale-multiple-principal">
    <div></div>
    <div></div>
    <div></div>
  </div>
<!-- </div> -->
<label class="titulo-loading">
  Cargando...
</label>
<p class="text-loading">
  ¡Gracias por tu tiempo! <b>Demorará sólo unos segundos.</b>
</p>
<p class="text-loading-responsive">
  ¡Gracias por tu tiempo! <br><b>Demorará sólo unos segundos.</b>
</p>
</div>
